const wrapper = document.querySelector('[data-product-form]');
const form = wrapper ? wrapper.querySelector('[data-cart-form]') : null;
if (wrapper && form) {
  const inputs = wrapper.querySelectorAll('[data-variant-option], [data-color-swatch]');
  const variantIdInput = form.querySelector('[data-variant-id]');
  const submitBtn = wrapper.querySelector('[data-add-to-cart]');
  const stockEl = wrapper.querySelector('[data-stock-indicator]');
  const priceEl = wrapper.querySelector('.price');
  const handle = wrapper.dataset.productHandle;

  let variantsData = null;
  const stockScript = wrapper.querySelector('[data-variant-stock]');
  let stockMap = {};
  try { stockMap = stockScript ? JSON.parse(stockScript.textContent) : {}; } catch (_) { stockMap = {}; }

  async function loadVariants() {
    if (variantsData) return variantsData;
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Failed to load variants: ${res.status}`);
    variantsData = await res.json();
    return variantsData;
  }

  function readSelected() {
    const values = [];
    form.querySelectorAll('fieldset[data-option-name]').forEach(fs => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) values.push(checked.value);
    });
    return values;
  }

  async function updateVariant() {
    const data = await loadVariants();
    const selected = readSelected();
    const variant = data.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    // Update price
    const priceText = new Intl.NumberFormat(document.documentElement.lang || 'nl', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
    }).format(variant.price / 100);
    if (priceEl) priceEl.querySelector('.price__current').textContent = priceText;
    // Update stock + submit state
    const stock = stockMap[variant.id] || { state: variant.available ? 'in' : 'out', count: 0 };
    submitBtn.disabled = stock.state === 'out';
    submitBtn.textContent = stock.state === 'out' ? (submitBtn.dataset.soldOut || 'Sold out')
      : stock.state === 'pre' ? (submitBtn.dataset.preOrder || 'Pre-order')
      : (submitBtn.dataset.addToCart || 'Add to cart');
    if (stockEl) {
      const labels = {
        in: stockEl.dataset.inStock,
        low: (stockEl.dataset.lowStock || '').replace('__COUNT__', stock.count),
        pre: stockEl.dataset.preOrder,
        out: stockEl.dataset.outOfStock
      };
      const span = document.createElement('span');
      span.className = `stock stock--${stock.state}`;
      span.textContent = labels[stock.state] || '';
      stockEl.replaceChildren(span);
    }
    // If variant has a featured media, switch gallery
    if (variant.featured_media && window.Sandee?.showProductMedia) {
      window.Sandee.showProductMedia(String(variant.featured_media.id));
    }
  }

  inputs.forEach(inp => inp.addEventListener('change', () => {
    updateVariant().catch(err => console.error('[Sandee] variant update failed:', err));
  }));

  // Intercept add-to-cart: submit via AJAX, then open drawer
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
    if (!res.ok) {
      const err = await res.json();
      alert(err.description || 'Error adding to cart');
      return;
    }
    if (window.Sandee?.openCart) window.Sandee.openCart();
  });

  // Mark selected radio parent labels, update colour legend text on swatch change
  form.addEventListener('change', (e) => {
    if (!e.target.matches('input[type="radio"]')) return;
    const fs = e.target.closest('fieldset');
    fs.querySelectorAll('label').forEach(l => l.classList.toggle('is-selected', l.contains(e.target.checked ? e.target : null)));
    if (e.target.matches('[data-color-swatch]')) {
      const legend = fs.querySelector('[data-color-legend]');
      if (legend) legend.textContent = e.target.value;
    }
  });
}
